import { tryGetHostApi } from "../app/externalApi/externalApi";
import { addPartCData } from "./TraceLogging";
// Wrapper class for logging Tracelogging events.
// Only one logEvent method is provided, because tracelogging events don't need privacy tags or event tags.
// LoggingLevel is required for all tracelogging events to make performance profiles easier to create
export class Trace {
    static async logEvent(provider, eventName, loggingLevel, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, 0 /* none */, 0 /* none */, 0 /* none */, loggingLevel, await addPartCData(partC));
        }
    }
}
